<div class="display-layout-column layout-gap-15">
  <div class="headline">Main Settings</div>
  <mat-divider class="headlineDivider"></mat-divider>
  <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Template Settings"> </mat-tab>
    <!-- <mat-tab label="Mail Settings"></mat-tab>-->
  </mat-tab-group>

  <mat-card>
    <mat-card-subtitle>clean up request and attachments</mat-card-subtitle>
    <mat-card-content>
      <div class="display-layout-row layout-gap-15">
        <mat-form-field appearance="fill">
          <mat-label>from date (eg in the past)</mat-label>
          <input matInput [matDatepicker]="picker" (dateChange)="addFromEvent('change', $event)">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>to date (eg today)</mat-label>
          <input matInput [matDatepicker]="pickerTo" (dateChange)="addToEvent('change', $event)">
          <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>
      </div>
    </mat-card-content>

    <button mat-stroked-button (click)="startCleaning()">Start CLEANING</button>

  </mat-card>

  @if (tab == 'templateSettings') {
    <div>
      <div>
        <h6>
          Short description of the placeholders:
        </h6>
        <ul >
          <li>[destination] will be replaced with final destination</li>
          <li>[packages] will be replaced with the number of packages</li>
          <li>[weight] will be replaced with the actual weight</li>
          <li>[reference] will be replaced with requestId </li>
          <li>[CW] will be replaced with chargeable Weight</li>
          <li>[note] will be replaced with note</li>
          <li>[cargoRequest] will be replaced with the special cargo Request</li>
          <li>[stackable] will be replaced with stackable</li>
          <li>[targeRate] will be replaced with the target rate</li>
          <li>[exOrigin] will be replaced with the available ex origin</li>
        </ul>
      </div>
      <mat-accordion>
        @for (template of templates; track template) {
          <mat-expansion-panel>
            <mat-expansion-panel-header (click)="templatePanelChanged(template.id)">
              <mat-panel-title>{{ template.templateType }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div [formGroup]="templateForm" class="display-layout-column">
              <div class="display-layout-column">
                <mat-form-field>
                  <mat-label>Subject</mat-label>
                  <input matInput formControlName="templateSubject" />
                  <mat-hint><b>NOTE: </b>In order to be able to assign the message correctly, the message must contain
                the placeholder "reference"</mat-hint>
              </mat-form-field>
            </div>
            <br>
              <angular-editor formControlName="templateBody" [config]="editorConfig"></angular-editor>
              <!--  <mat-form-field>
              <mat-label>Message</mat-label>
              <textarea class="textarea" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" matInput
                formControlName="templateBody">
              </textarea>
            </mat-form-field>-->
            <div class="display-flex justify-content-end">
              <button  mat-button (click)="saveTemplate(template)">
                Save
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
}

@if (tab == 'mailSettings') {
  <div>mail settings</div>
}
</div>
